export const ProviderEnum = {
  BEHAVIORAL: "BEHAVIORAL",
  BEHAVIORAL_INTAKE: "BEHAVIORAL_INTAKE",
  CARE_MANAGER: "CARE_MANAGER",
  CASE_MANAGER: "CASE_MANAGER",
  CASE_MANAGER_SUPERVISOR: "CASE_MANAGER_SUPERVISOR",
  PCP: "PCP",
  PEER: "PEER",
  PRESCRIBE: "PRESCRIBE",
} as const;
